import { ErrorData } from '../redux/slices/errors'
import ErrorMessage from '../types/ErrorMessage'

export function createSuperAdminErrorMessage(errorData: ErrorData): ErrorMessage {
  let message: ErrorMessage = { key: 'default', message: 'somethingWentWrong' }

  if (errorData.error.response === undefined) {
    message = { key: 'default', message: errorData.error.message }
    return message
  }

  switch (errorData.error.response.status) {
    case 422:
      if (errorData.error.response.data) {
        const errors = errorData.error.response.data.errors
        const firstError = Object.entries(errors).find(([_, v]) => v.length > 0)

        if (firstError) {
          const [key, value] = firstError
          message = { key, message: value[0] }
        } else {
          message = { key: 'default', message: 'unprocessableEntity' }
        }
      } else {
        message = { key: 'default', message: 'unprocessableEntity' }
      }
      break
  }

  return message
}

export function createSimpleErrorMessage(errorData: ErrorData): ErrorMessage {
  let message: ErrorMessage = { key: 'default', message: 'somethingWentWrong' }

  if (errorData.error.response === undefined) {
    message = { key: 'default', message: errorData.error.message }
    return message
  }

  switch (errorData.error.response.status) {
    case 422:
      if (errorData.error.response.data) {
        const errors = errorData.error.response.data.errors
        const firstError = Object.entries(errors).find(([_, v]) => v.length > 0)

        if (firstError) {
          const [key, value] = firstError
          message = { key, message: value[0] }
        } else {
          message = { key: 'default', message: 'unprocessableEntity' }
        }
      } else {
        message = { key: 'default', message: 'unprocessableEntity' }
      }
      break
  }

  return message
}
